import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.sales');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';

@Component({
    selector: 'wiz-page-sales',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.sales/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageSalesComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public category: string = '';
    public sub: string = '';
    public routerSub: any;

    // 당일매출종합
    public summaryDate: string = '';
    public summaryData: any = { total_amount: 0, total_discount: 0, total_count: 0, payment_summary: {}, sales: [] };

    // 당일매출상세
    public detailDate: string = '';
    public detailSales: any[] = [];
    public detailTotal: number = 0;
    public detailPage: number = 1;

    // 영수증상세
    public receiptItems: any[] = [];
    public selectedSaleId: string = '';

    // 일자별
    public rangeStart: string = '';
    public rangeEnd: string = '';
    public rangeSales: any[] = [];

    // 매출항목표시
    public displayColumns: string[] = ['receipt_no', 'sale_date', 'payment_type', 'total_amount', 'discount_amount', 'status'];
    public allDisplayColumns: any[] = [
        { key: 'receipt_no', label: '영수증번호' }, { key: 'sale_date', label: '매출일자' },
        { key: 'payment_type', label: '결제방법' }, { key: 'total_amount', label: '총액' },
        { key: 'discount_amount', label: '할인액' }, { key: 'net_amount', label: '순매출' },
        { key: 'status', label: '상태' }, { key: 'cashier', label: '캐셔' },
        { key: 'table_no', label: '테이블' }, { key: 'customer_count', label: '객수' },
        { key: 'tax_amount', label: '세액' }, { key: 'created', label: '거래시간' }
    ];

    // 영수증별상세현황
    public receiptStart: string = '';
    public receiptEnd: string = '';
    public receiptNoSearch: string = '';
    public receiptSalesList: any[] = [];
    public receiptSalesTotal: number = 0;
    public receiptSalesPage: number = 1;

    // 비매출내역
    public nonSalesStart: string = '';
    public nonSalesEnd: string = '';
    public nonSalesList: any[] = [];

    // 요일별
    public weekdayStart: string = '';
    public weekdayEnd: string = '';
    public weekdaySales: any[] = [];

    // 월별
    public monthlyYear: string = '';
    public monthlySales: any[] = [];

    // 일기간
    public periodStart: string = '';
    public periodEnd: string = '';
    public periodSummary: any = { count: 0, total_amount: 0, total_discount: 0, avg_amount: 0, daily: [] };

    // 기준별 매출현황 (FN-0016)
    public groupStart: string = '';
    public groupEnd: string = '';
    public groupData: any[] = [];
    public groupTypeMap: any = {
        '테이블별': 'table', '포스별': 'pos', '상품별': 'product',
        '매장상품별': 'store_product', '판매자별': 'cashier', '주문자별': 'orderer',
        '할인구분별': 'discount', '바코드별': 'barcode'
    };
    public groupQtyLabel: any = { 'product': true, 'store_product': true, 'barcode': true };

    // 반품현황
    public returnStart: string = '';
    public returnEnd: string = '';
    public returnSales: any[] = [];
    public returnTotalAmount: number = 0;

    // POS정산내역
    public settlementStart: string = '';
    public settlementEnd: string = '';
    public settlementList: any[] = [];

    // 대비기간매출분석
    public compareStartA: string = '';
    public compareEndA: string = '';
    public compareStartB: string = '';
    public compareEndB: string = '';
    public compareA: any = { count: 0, total_amount: 0, total_discount: 0, cash: 0, card: 0 };
    public compareB: any = { count: 0, total_amount: 0, total_discount: 0, cash: 0, card: 0 };

    // 상품ABC분석
    public abcStart: string = '';
    public abcEnd: string = '';
    public abcData: any[] = [];
    public abcGrandTotal: number = 0;

    // 월력판매분석
    public calYear: string = '';
    public calMonth: string = '';
    public calData: any = {};

    // 칼라사이즈별매출현황
    public colorSizeStart: string = '';
    public colorSizeEnd: string = '';
    public colorSizeData: any[] = [];

    // 판매추이분석
    public trendStart: string = '';
    public trendEnd: string = '';
    public trendData: any[] = [];

    // 날씨별매출분석
    public weatherStart: string = '';
    public weatherEnd: string = '';
    public weatherData: any[] = [];
    public weatherSummary: any[] = [];

    // 영업일보
    public reportDate: string = '';
    public reportSummary: any = { date: '', count: 0, total_amount: 0, total_discount: 0, cash: 0, card: 0, etc_amount: 0, tax: 0 };
    public reportTopProducts: any[] = [];
    public reportHourly: any[] = [];

    // 매출목표관리
    public targetYearMonth: string = '';
    public targetList: any[] = [];
    public targetEditId: string = '';
    public targetForm: any = { target_date: '', target_amount: 0, day_weight: 1.0 };

    // 상품별월매출조회
    public pmYear: string = '';
    public pmProductName: string = '';
    public pmData: any[] = [];
    public pmMonths: string[] = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];

    // 주문취소
    public cancelStart: string = '';
    public cancelEnd: string = '';
    public cancelList: any[] = [];

    // 카드승인현황 (3종 공용)
    public cardApprovalStart: string = '';
    public cardApprovalEnd: string = '';
    public cardApprovalData: any[] = [];
    public cardViewTypeMap: any = {
        '카드승인현황': 'all',
        '카드승인현황(매입사별)': 'acquirer',
        '제휴카드승인현황': 'alliance'
    };

    // 현금영수승인현황
    public cashReceiptStart: string = '';
    public cashReceiptEnd: string = '';
    public cashReceiptList: any[] = [];

    // 비매출승인현황
    public nonSalesApprStart: string = '';
    public nonSalesApprEnd: string = '';
    public nonSalesApprList: any[] = [];

    // 모바일쿠폰승인현황
    public couponStart: string = '';
    public couponEnd: string = '';
    public couponList: any[] = [];

    // 배달현황 (공용 날짜)
    public dlvStart: string = '';
    public dlvEnd: string = '';
    public dlvDailyData: any[] = [];
    public dlvDetailData: any[] = [];
    public dlvProductData: any[] = [];
    public dlvZoneData: any[] = [];
    public dlvDriverData: any[] = [];
    public dlvDriverIOData: any[] = [];
    public dlvZoneTypeMap: any = { '배달지분류별내역': 'parent', '배달지별내역': 'zone' };
    public dlvDriverTypeMap: any = { '배달원별 배달/수금내역': 'delivery', '배달원별 입출금내역': 'io' };

    // 기타
    public miscStart: string = '';
    public miscEnd: string = '';
    public custSalesData: any[] = [];
    public trvAgencyData: any[] = [];
    public drvCommData: any[] = [];
    public currPayData: any[] = [];
    public pointSalesData: any[] = [];

    public categories: any = {
        'status': {
            label: '매출현황',
            items: ['당일매출종합현황', '당일매출상세현황', '영수증일자별매출상세현황', '일자별', '요일별', '월별', '일기간', '테이블별', '포스별', '상품별', '매장상품별', '판매자별', '주문자별', '컵보증금 판매현황', '할인구분별', '바코드별', '반품현황', 'POS정산내역']
        },
        'analysis': {
            label: '매출분석',
            items: ['대비기간매출분석', '상품ABC분석', '월력판매분석', '판매추이분석', '영업일보', '매출목표관리', '상품별월매출조회']
        },
        'order': {
            label: '주문분석',
            items: ['주문취소']
        },
        'approval': {
            label: '승인현황',
            items: ['승인현황', '모바일쿠폰승인현황']
        },
        'delivery': {
            label: '배달현황',
            items: ['배달현황', '배달대행서비스']
        },
        'misc': {
            label: '기타',
            items: ['객수매출현황']
        }
    };

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        const today = new Date().toISOString().split('T')[0];
        this.summaryDate = today;
        this.detailDate = today;
        this.rangeStart = today;
        this.rangeEnd = today;
        this.receiptStart = today;
        this.receiptEnd = today;
        this.nonSalesStart = today;
        this.nonSalesEnd = today;
        this.weekdayStart = today;
        this.weekdayEnd = today;
        this.monthlyYear = String(new Date().getFullYear());
        this.periodStart = today;
        this.periodEnd = today;
        this.groupStart = today;
        this.groupEnd = today;
        this.returnStart = today;
        this.returnEnd = today;
        this.settlementStart = today;
        this.settlementEnd = today;
        this.compareStartA = today;
        this.compareEndA = today;
        this.compareStartB = today;
        this.compareEndB = today;
        this.abcStart = today;
        this.abcEnd = today;
        this.calYear = String(new Date().getFullYear());
        this.calMonth = String(new Date().getMonth() + 1).padStart(2, '0');
        this.colorSizeStart = today;
        this.colorSizeEnd = today;
        this.trendStart = new Date(Date.now() - 30 * 86400000).toISOString().split('T')[0];
        this.trendEnd = today;
        this.weatherStart = this.trendStart;
        this.weatherEnd = today;
        this.reportDate = today;
        this.targetYearMonth = today.substring(0, 7);
        this.pmYear = String(new Date().getFullYear());
        this.cancelStart = today;
        this.cancelEnd = today;
        this.cardApprovalStart = today;
        this.cardApprovalEnd = today;
        this.cashReceiptStart = today;
        this.cashReceiptEnd = today;
        this.nonSalesApprStart = today;
        this.nonSalesApprEnd = today;
        this.couponStart = today;
        this.couponEnd = today;
        this.dlvStart = today;
        this.dlvEnd = today;
        this.miscStart = today;
        this.miscEnd = today;
        await this.updateRoute();
        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                await this.updateRoute();
                await this.service.render();
            }
        });
        await this.service.render();
    }

    ngOnDestroy() { if (this.routerSub) this.routerSub.unsubscribe(); }

    private async updateRoute() {
        const seg = WizRoute.segment;
        this.category = seg.category || 'status';
        try { this.sub = seg.sub ? decodeURIComponent(seg.sub) : ''; } catch { this.sub = seg.sub || ''; }
        if (!seg.category) {
            this.service.href('/sales/status');
            return;
        }
        if (this.sub) await this.loadSubData();
    }

    public categoryKeys(): string[] { return Object.keys(this.categories); }
    public isActiveCat(key: string): boolean { return this.category === key; }

    public async selectSub(item: string) {
        this.service.href(`/sales/${this.category}/${encodeURIComponent(item)}`);
    }

    private async loadSubData() {
        if (this.sub === '당일매출종합현황') await this.loadDailySummary();
        if (this.sub === '당일매출상세현황') await this.loadDailyDetail();
        if (this.sub === '영수증일자별매출상세현황') await this.loadReceiptSales();
        if (this.sub === '일자별') await this.loadDateRange();
        if (this.sub === '요일별') await this.loadWeekday();
        if (this.sub === '월별') await this.loadMonthly();
        if (this.sub === '일기간') await this.loadPeriod();
        if (this.groupTypeMap[this.sub]) await this.loadGroupSales();
        if (this.sub === '반품현황') await this.loadReturnSales();
        if (this.sub === 'POS정산내역') await this.loadSettlements();
        if (this.sub === '대비기간매출분석') await this.loadComparePeriod();
        if (this.sub === '상품ABC분석') await this.loadAbcAnalysis();
        if (this.sub === '월력판매분석') await this.loadCalendarSales();
        if (this.sub === '판매추이분석') await this.loadSalesTrend();
        if (this.sub === '영업일보') await this.loadDailyReport();
        if (this.sub === '매출목표관리') await this.loadSalesTargets();
        if (this.sub === '상품별월매출조회') await this.loadProductMonthlySales();
        if (this.sub === '주문취소') await this.loadOrderCancels();
        if (this.sub === '모바일쿠폰승인현황') await this.loadMobileCoupons();
        if (this.sub === '객수매출현황') await this.loadCustomerSales();
    }

    public paymentKeys(): string[] {
        return Object.keys(this.summaryData.payment_summary || {});
    }

    // ===== 당일매출종합 =====
    public async loadDailySummary() {
        let res = await wiz.call("daily_summary", { date: this.summaryDate });
        if (res.code === 200) this.summaryData = res.data;
        await this.service.render();
    }

    // ===== 당일매출상세 =====
    public async loadDailyDetail() {
        let res = await wiz.call("daily_detail", { date: this.detailDate, page: this.detailPage });
        if (res.code === 200) {
            this.detailSales = res.data?.data || [];
            this.detailTotal = res.data?.total || 0;
        }
        await this.service.render();
    }

    // ===== 영수증상세 =====
    public async viewReceipt(saleId: string) {
        this.selectedSaleId = saleId;
        let res = await wiz.call("receipt_detail", { sale_id: saleId });
        if (res.code === 200) this.receiptItems = res.data?.data || [];
        await this.service.render();
    }

    // ===== 일자별 매출현황 =====
    public async loadDateRange() {
        let res = await wiz.call("date_range_summary", { start_date: this.rangeStart, end_date: this.rangeEnd });
        if (res.code === 200) this.rangeSales = res.data?.data || [];
        await this.service.render();
    }

    // ===== 매출항목표시 =====
    public async loadDisplayConfig() {
        let res = await wiz.call("display_config_load");
        if (res.code === 200 && res.data?.columns) {
            try { this.displayColumns = JSON.parse(res.data.columns); } catch (e) { }
        }
        await this.service.render();
    }

    public isColumnChecked(key: string): boolean {
        return this.displayColumns.includes(key);
    }

    public toggleColumn(key: string) {
        const idx = this.displayColumns.indexOf(key);
        if (idx >= 0) this.displayColumns.splice(idx, 1);
        else this.displayColumns.push(key);
        this.service.render();
    }

    public async saveDisplayConfig() {
        let res = await wiz.call("display_config_save", { columns: JSON.stringify(this.displayColumns) });
        if (res.code === 200) await this.service.modal.show({ title: '', message: '저장되었습니다.', cancel: false, action: '확인', status: 'success' });
        else await this.service.modal.show({ title: '', message: '저장 실패', cancel: false, action: '확인', status: 'error' });
    }

    // ===== 영수증별상세현황 =====
    public async loadReceiptSales() {
        let res = await wiz.call("receipt_sales_list", { start_date: this.receiptStart, end_date: this.receiptEnd, receipt_no: this.receiptNoSearch, page: this.receiptSalesPage });
        if (res.code === 200) { this.receiptSalesList = res.data?.data || []; this.receiptSalesTotal = res.data?.total || 0; }
        await this.service.render();
    }

    // ===== 비매출내역 =====
    public async loadNonSales() {
        let res = await wiz.call("non_sales_list", { start_date: this.nonSalesStart, end_date: this.nonSalesEnd });
        if (res.code === 200) this.nonSalesList = res.data?.data || [];
        await this.service.render();
    }

    // ===== 요일별 매출현황 =====
    public async loadWeekday() {
        let res = await wiz.call("weekday_summary", { start_date: this.weekdayStart, end_date: this.weekdayEnd });
        if (res.code === 200) this.weekdaySales = res.data?.data || [];
        await this.service.render();
    }

    // ===== 월별 매출현황 =====
    public async loadMonthly() {
        let res = await wiz.call("monthly_summary", { year: this.monthlyYear });
        if (res.code === 200) this.monthlySales = res.data?.data || [];
        await this.service.render();
    }

    public monthlyTotal(): number {
        return this.monthlySales.reduce((s: number, r: any) => s + (r.total_amount || 0), 0);
    }

    // ===== 일기간 매출현황 =====
    public async loadPeriod() {
        let res = await wiz.call("period_summary", { start_date: this.periodStart, end_date: this.periodEnd });
        if (res.code === 200) this.periodSummary = res.data?.data || { count: 0, total_amount: 0, total_discount: 0, avg_amount: 0, daily: [] };
        await this.service.render();
    }

    // ===== 기준별 매출현황 (FN-0016) =====
    public async loadGroupSales() {
        const groupType = this.groupTypeMap[this.sub];
        if (!groupType) return;
        let res = await wiz.call("sales_group_query", { group_type: groupType, start_date: this.groupStart, end_date: this.groupEnd });
        if (res.code === 200) this.groupData = res.data?.data || [];
        await this.service.render();
    }

    public isQtyGroup(): boolean {
        return !!this.groupQtyLabel[this.groupTypeMap[this.sub]];
    }

    public groupTotal(): number {
        return this.groupData.reduce((s: number, r: any) => s + (r.total_amount || 0), 0);
    }

    // ===== 반품현황 (FN-0017) =====
    public async loadReturnSales() {
        let res = await wiz.call("return_sales_list", { start_date: this.returnStart, end_date: this.returnEnd });
        if (res.code === 200) {
            this.returnSales = res.data?.data || [];
            this.returnTotalAmount = res.data?.total_amount || 0;
        }
        await this.service.render();
    }

    // ===== POS정산내역 (FN-0017) =====
    public async loadSettlements() {
        let res = await wiz.call("pos_settlement_list", { start_date: this.settlementStart, end_date: this.settlementEnd });
        if (res.code === 200) this.settlementList = res.data?.data || [];
        await this.service.render();
    }

    // ===== 대비기간매출분석 (FN-0018) =====
    public async loadComparePeriod() {
        let res = await wiz.call("compare_period_sales", { start_a: this.compareStartA, end_a: this.compareEndA, start_b: this.compareStartB, end_b: this.compareEndB });
        if (res.code === 200) {
            this.compareA = res.data?.period_a || this.compareA;
            this.compareB = res.data?.period_b || this.compareB;
        }
        await this.service.render();
    }

    public compareDiff(field: string): number {
        return (this.compareA[field] || 0) - (this.compareB[field] || 0);
    }

    // ===== 상품ABC분석 (FN-0018) =====
    public async loadAbcAnalysis() {
        let res = await wiz.call("abc_analysis", { start_date: this.abcStart, end_date: this.abcEnd });
        if (res.code === 200) {
            this.abcData = res.data?.data || [];
            this.abcGrandTotal = res.data?.grand_total || 0;
        }
        await this.service.render();
    }

    public abcCount(grade: string): number {
        return this.abcData.filter((r: any) => r.grade === grade).length;
    }

    public abcGradeColor(grade: string): string {
        if (grade === 'A') return 'bg-blue-100 text-blue-700';
        if (grade === 'B') return 'bg-yellow-100 text-yellow-700';
        return 'bg-slate-100 text-slate-600';
    }

    // ===== 월력판매분석 (FN-0018) =====
    public async loadCalendarSales() {
        let res = await wiz.call("calendar_sales", { year: this.calYear, month: this.calMonth });
        if (res.code === 200) this.calData = res.data?.data || {};
        await this.service.render();
    }

    public getCalendarWeeks(): any[][] {
        const y = parseInt(this.calYear);
        const m = parseInt(this.calMonth) - 1;
        const firstDay = new Date(y, m, 1);
        const lastDay = new Date(y, m + 1, 0).getDate();
        const startWeekday = firstDay.getDay();
        const weeks: any[][] = [];
        let week: any[] = [];
        for (let i = 0; i < startWeekday; i++) week.push(null);
        for (let d = 1; d <= lastDay; d++) {
            const dateStr = `${this.calYear}-${this.calMonth}-${String(d).padStart(2, '0')}`;
            const data = this.calData[dateStr] || { count: 0, total_amount: 0 };
            week.push({ day: d, date: dateStr, ...data });
            if (week.length === 7) { weeks.push(week); week = []; }
        }
        if (week.length > 0) { while (week.length < 7) week.push(null); weeks.push(week); }
        return weeks;
    }

    public calMonthTotal(): number {
        let total = 0;
        for (const key of Object.keys(this.calData)) total += this.calData[key]?.total_amount || 0;
        return total;
    }

    // ===== 칼라사이즈별매출현황 (FN-0018) =====
    public async loadColorSizeSales() {
        let res = await wiz.call("color_size_sales", { start_date: this.colorSizeStart, end_date: this.colorSizeEnd });
        if (res.code === 200) this.colorSizeData = res.data?.data || [];
        await this.service.render();
    }

    public colorSizeTotal(): number {
        return this.colorSizeData.reduce((s: number, r: any) => s + (r.total_amount || 0), 0);
    }

    // ===== 판매추이분석 (FN-0018) =====
    public async loadSalesTrend() {
        let res = await wiz.call("sales_trend", { start_date: this.trendStart, end_date: this.trendEnd });
        if (res.code === 200) this.trendData = res.data?.data || [];
        await this.service.render();
    }

    public trendMax(): number {
        return Math.max(...this.trendData.map((r: any) => r.total_amount || 0), 1);
    }

    // ===== 날씨별매출분석 (FN-0018) =====
    public async loadWeatherSales() {
        let res = await wiz.call("weather_sales", { start_date: this.weatherStart, end_date: this.weatherEnd });
        if (res.code === 200) {
            this.weatherData = res.data?.data || [];
            this.weatherSummary = res.data?.summary || [];
        }
        await this.service.render();
    }

    // ===== 영업일보 (FN-0018) =====
    public async loadDailyReport() {
        let res = await wiz.call("daily_report", { date: this.reportDate });
        if (res.code === 200) {
            this.reportSummary = res.data?.summary || this.reportSummary;
            this.reportTopProducts = res.data?.top_products || [];
            this.reportHourly = res.data?.hourly || [];
        }
        await this.service.render();
    }

    // ===== 매출목표관리 (FN-0018) =====
    public async loadSalesTargets() {
        let res = await wiz.call("sales_target_list", { year_month: this.targetYearMonth });
        if (res.code === 200) this.targetList = res.data?.data || [];
        await this.service.render();
    }

    public async saveSalesTarget() {
        const data: any = { ...this.targetForm, year_month: this.targetYearMonth };
        if (this.targetEditId) data.id = this.targetEditId;
        let res = await wiz.call("sales_target_save", data);
        if (res.code === 200) {
            this.targetEditId = '';
            this.targetForm = { target_date: '', target_amount: 0, day_weight: 1.0 };
            await this.loadSalesTargets();
        }
        await this.service.render();
    }

    public async editTarget(item: any) {
        this.targetEditId = item.id;
        this.targetForm = { target_date: item.target_date, target_amount: item.target_amount, day_weight: item.day_weight };
        await this.service.render();
    }

    public async deleteTarget(id: string) {
        let res = await wiz.call("sales_target_delete", { id });
        if (res.code === 200) await this.loadSalesTargets();
    }

    public targetTotal(): number {
        return this.targetList.reduce((s: number, r: any) => s + (r.target_amount || 0), 0);
    }

    // ===== 상품별월매출조회 (FN-0018) =====
    public async loadProductMonthlySales() {
        let res = await wiz.call("product_monthly_sales", { year: this.pmYear, product_name: this.pmProductName });
        if (res.code === 200) this.pmData = res.data?.data || [];
        await this.service.render();
    }

    public pmGetMonth(item: any, month: string): any {
        const key = `${this.pmYear}-${month}`;
        return item.months?.[key] || { qty: 0, amount: 0 };
    }

    // ===== 주문취소 (FN-0019) =====
    public async loadOrderCancels() {
        let res = await wiz.call("order_cancel_list", { start_date: this.cancelStart, end_date: this.cancelEnd });
        if (res.code === 200) this.cancelList = res.data?.data || [];
        await this.service.render();
    }

    public cancelTotal(): number {
        return this.cancelList.reduce((s: number, r: any) => s + (r.amount || 0), 0);
    }

    // ===== 카드승인현황 (FN-0019) =====
    public async loadCardApprovals() {
        const viewType = this.cardViewTypeMap[this.sub] || 'all';
        let res = await wiz.call("card_approval_list", { start_date: this.cardApprovalStart, end_date: this.cardApprovalEnd, view_type: viewType });
        if (res.code === 200) this.cardApprovalData = res.data?.data || [];
        await this.service.render();
    }

    public isCardGrouped(): boolean {
        return this.cardViewTypeMap[this.sub] === 'acquirer';
    }

    public cardTotal(): number {
        const key = this.isCardGrouped() ? 'total_amount' : 'amount';
        return this.cardApprovalData.reduce((s: number, r: any) => s + (r[key] || 0), 0);
    }

    // ===== 현금영수승인현황 (FN-0019) =====
    public async loadCashReceipts() {
        let res = await wiz.call("cash_receipt_list", { start_date: this.cashReceiptStart, end_date: this.cashReceiptEnd });
        if (res.code === 200) this.cashReceiptList = res.data?.data || [];
        await this.service.render();
    }

    // ===== 비매출승인현황 (FN-0019) =====
    public async loadNonSalesApprovals() {
        let res = await wiz.call("non_sales_approval_list", { start_date: this.nonSalesApprStart, end_date: this.nonSalesApprEnd });
        if (res.code === 200) this.nonSalesApprList = res.data?.data || [];
        await this.service.render();
    }

    // ===== 모바일쿠폰승인현황 (FN-0019) =====
    public async loadMobileCoupons() {
        let res = await wiz.call("mobile_coupon_list", { start_date: this.couponStart, end_date: this.couponEnd });
        if (res.code === 200) this.couponList = res.data?.data || [];
        await this.service.render();
    }

    // ===== 배달현황 (FN-0020) =====
    public async loadDeliveryDaily() {
        let res = await wiz.call("delivery_daily", { start_date: this.dlvStart, end_date: this.dlvEnd });
        if (res.code === 200) this.dlvDailyData = res.data?.data || [];
        await this.service.render();
    }

    public async loadDeliveryDetail() {
        let res = await wiz.call("delivery_detail", { start_date: this.dlvStart, end_date: this.dlvEnd });
        if (res.code === 200) this.dlvDetailData = res.data?.data || [];
        await this.service.render();
    }

    public async loadDeliveryProducts() {
        let res = await wiz.call("delivery_products", { start_date: this.dlvStart, end_date: this.dlvEnd });
        if (res.code === 200) this.dlvProductData = res.data?.data || [];
        await this.service.render();
    }

    public async loadDeliveryZone() {
        const zt = this.dlvZoneTypeMap[this.sub] || 'zone';
        let res = await wiz.call("delivery_zone_summary", { start_date: this.dlvStart, end_date: this.dlvEnd, zone_type: zt });
        if (res.code === 200) this.dlvZoneData = res.data?.data || [];
        await this.service.render();
    }

    public async loadDeliveryDriver() {
        const qt = this.dlvDriverTypeMap[this.sub] || 'delivery';
        let res = await wiz.call("delivery_driver_summary", { start_date: this.dlvStart, end_date: this.dlvEnd, query_type: qt });
        if (res.code === 200) {
            if (qt === 'io') this.dlvDriverIOData = res.data?.data || [];
            else this.dlvDriverData = res.data?.data || [];
        }
        await this.service.render();
    }

    // ===== 기타 (FN-0020) =====
    public async loadCustomerSales() {
        let res = await wiz.call("customer_count_sales", { start_date: this.miscStart, end_date: this.miscEnd });
        if (res.code === 200) this.custSalesData = res.data?.data || [];
        await this.service.render();
    }

    public async loadTravelAgency() {
        let res = await wiz.call("travel_agency_sales", { start_date: this.miscStart, end_date: this.miscEnd });
        if (res.code === 200) this.trvAgencyData = res.data?.data || [];
        await this.service.render();
    }

    public async loadDriverComm() {
        let res = await wiz.call("driver_commission_summary", { start_date: this.miscStart, end_date: this.miscEnd });
        if (res.code === 200) this.drvCommData = res.data?.data || [];
        await this.service.render();
    }

    public async loadCurrencyPay() {
        let res = await wiz.call("payment_currency_summary", { start_date: this.miscStart, end_date: this.miscEnd });
        if (res.code === 200) this.currPayData = res.data?.data || [];
        await this.service.render();
    }

    public async loadPointSales() {
        let res = await wiz.call("member_point_discount_sales", { start_date: this.miscStart, end_date: this.miscEnd });
        if (res.code === 200) this.pointSalesData = res.data?.data || [];
        await this.service.render();
    }

    // ===== placeholder 판단 =====
    public isImplemented(): boolean {
        const impl = [
            '당일매출종합현황', '당일매출상세현황', '영수증일자별매출상세현황',
            '일자별', '요일별', '월별', '일기간', '반품현황', 'POS정산내역',
            '대비기간매출분석', '상품ABC분석', '월력판매분석',
            '판매추이분석', '영업일보', '매출목표관리', '상품별월매출조회',
            '주문취소', '모바일쿠폰승인현황', '객수매출현황'
        ];
        return impl.includes(this.sub) || !!this.groupTypeMap[this.sub];
    }
}

export default PageSalesComponent;